import { GET_REFERRALS_TOTAL, GET_REFERRAL_REWARDS } from 'network/config/endpoints';
import api from 'network/config/setAuthHeader';
import { ReferralCodeResponse } from 'TYPES/api.body';
import { getCustomer } from './profile';

export type ReferralAwards = {
  totalReward: number;
  referralCount: number;
  rewardPerReferral: number;
  discountPercent: number;
};

export type ReferralFriend = {
  id: number;
  name: string;
  reward: number;
  createdAt: string;
};

export interface ReferralList {
  totalReward: number;
  referralCount: number;
  rewardPerReferral: number;
  discountPercent: number;
  friends: ReferralFriend[];
}

const asNumber = (value: unknown) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const readAwards = (record: Record<string, unknown> | undefined): ReferralAwards => ({
  totalReward: asNumber(record?.total_reward ?? record?.totalReward),
  referralCount: asNumber(record?.referral_count ?? record?.referralCount),
  rewardPerReferral: asNumber(record?.reward_per_referral ?? record?.rewardPerReferral) || 500,
  discountPercent: asNumber(record?.discount_percent ?? record?.discountPercent)
});

export const getReferralLink = async (): Promise<ReferralCodeResponse> => {
  const customer = await getCustomer();
  const code = customer.data?.referral_code ?? '';
  return { status: 'success', message: code };
};

export const getReferralRewards = async (): Promise<ReferralAwards> => {
  const { data } = await api.get(GET_REFERRAL_REWARDS);
  const record = (data?.data ?? data) as Record<string, unknown>;
  return readAwards(record);
};

export const getReferralCount = async (): Promise<ReferralList> => {
  const { data } = await api.get(GET_REFERRALS_TOTAL);
  const rows = Array.isArray(data?.data) ? data.data : [];
  const awards = readAwards((data?.meta ?? {}) as Record<string, unknown>);
  const friends: ReferralFriend[] = rows.map((row: Record<string, unknown>, index: number) => {
    const name = String(row.name ?? `${row.firstname ?? ''} ${row.lastname ?? ''}`).trim();
    return {
      id: asNumber(row.id) || index + 1,
      name: name || 'Friend',
      reward: asNumber(row.reward) || 500,
      createdAt: String(row.created_at ?? row.createdAt ?? '')
    };
  });

  return {
    ...awards,
    referralCount: awards.referralCount || friends.length,
    friends
  };
};
